import { render } from "./InputExperience.vue?vue&type=template&id=6085bdd4"
import script from "./InputExperience.vue?vue&type=script&lang=js"
export * from "./InputExperience.vue?vue&type=script&lang=js"
script.render = render

export default script